import globalEvents from "@/events/global-events"
import eventHandlers from "./event-handlers"
import EventBus from "@/events/event-bus"

let _eventBus: Nullable<typeof EventBus> = null

function init(bus: typeof EventBus) {
  if (_eventBus) throw new Error("Ayva event bus has already been initialized!")

  _eventBus = bus
  registerEventListeners()
}

function registerEventListeners() {
  _eventBus!.on(globalEvents.LOG_IN, eventHandlers.handleLogInEvent)
  _eventBus!.on(globalEvents.LOG_OUT, eventHandlers.handleLogOutEvent)
}

export default {
  init
}
